import React, { Component } from 'react';

export default class StockCheckbox extends Component {
	static findQuestionByMeta(questions, meta, value) {
		const question = questions.filter(qst => qst.meta[meta] === value);
		return question[0];
	}

	renderOptions() {
		const {
			valueField,
			nameField,
			classContainer,
			onChange,
			options,
		} = this.props;


		return options.map(option => (
			<div className={`form-check ${classContainer}`} key={option.value}>
				<label className="form-check-label" htmlFor={nameField + option.value}>
					<input
						className="form-check-input css-checkbox"
						type="checkbox"
						value={option.value}
						id={nameField + option.value}
						name={nameField}
						onChange={onChange}
						checked={(valueField.indexOf(option.value) !== -1)}
					/>
					<i />
					{option.label}
					{
						(typeof option.image !== 'undefined')
							? (
								<div className="checkbox-image">
									<img src={option.image} alt={option.label} />
								</div>
							)
							: ''
					}
				</label>
			</div>
		));
	}

	render() {
		const {
			required,
			classContainer,
			meta,
			messageErrorField,
			questions,
			question,
		} = this.props;

		const charVeiculos = StockCheckbox.findQuestionByMeta(questions, 'alias', 'char_veiculos');
		const kmCarros = StockCheckbox.findQuestionByMeta(questions, 'alias', 'km_carros');
		const procedenciaCarros = StockCheckbox.findQuestionByMeta(questions, 'alias', 'procedencia_carros');
		const kmMotos = StockCheckbox.findQuestionByMeta(questions, 'alias', 'km_motos');
		if (
			meta.alias === 'char_veiculos'
			|| (
				typeof charVeiculos !== 'undefined'
				&& (
					Array.isArray(charVeiculos.valueField)
				)
				&& (
					(charVeiculos.valueField.indexOf('Carros') !== -1
					&& (
						meta.alias === 'km_carros'
						|| (
							(
								Array.isArray(kmCarros.valueField)
								&& kmCarros.valueField.length > 0
							)
							&& (
								meta.alias === 'procedencia_carros'
								|| (
									meta.alias === 'modelos_carros'
									&& Array.isArray(procedenciaCarros.valueField)
									&& procedenciaCarros.valueField.length > 0
								)
							)
						)
					))
					|| (
						charVeiculos.valueField.indexOf('Motos') !== -1
						&& (
							meta.alias === 'km_motos'
							|| (
								(
									Array.isArray(kmMotos.valueField)
									&& kmMotos.valueField.length > 0
								)
								&& (
									meta.alias === 'procedencia_motos'
								)
							)
						)
					)
				)
			)
		) {
			return (
				<div className={`component-question-data ${classContainer}`}>
					<p>
						{typeof meta.alt_title !== 'undefined' ? <span>{meta.alt_title}</span> : question }
						{required && typeof meta.alt_title === 'undefined' ? <span className="required">*Campos de preenchimento obrigatório.</span> : ''}
					</p>
					<div className="checks-container">
						{ this.renderOptions() }
					</div>
					<div className="help-block">{messageErrorField}</div>
				</div>
			);
		}

		return '';
	}
}
